import type { ApolloCache } from "@apollo/client";
import { insertIntoConnection, removeFromConnection } from "#app/lib/data/connection-cache-utils";

// Reason has no keyFields override in the Apollo type policies, so the cache
// keys it by `id` — identifiers passed to the connection helpers must carry
// `id`, never the legacy-style `reasonId` twin (toReference answers undefined
// for an object it cannot key, and the helpers then no-op).

export function addReasonToCache(cache: ApolloCache, reason: { id: string }) {
  insertIntoConnection(cache, "reasons", "ReasonEdge", {
    __typename: "Reason",
    id: reason.id,
  });
}

export function removeReasonFromCache(cache: ApolloCache, reason: { id: string }) {
  removeFromConnection(
    cache,
    "reasons",
    { __typename: "Reason", id: reason.id },
    { evict: true },
  );
}
